import script from "./control-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./control-search.vue?vue&type=script&setup=true&lang=ts"

import "./control-search.vue?vue&type=style&index=0&id=37682076&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37682076"]])

export default __exports__